import React from 'react';
import { Button, Icon, Skeleton } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import { useAppSelector } from 'app/hooks';
import { isOperationalTableViewEnabled } from 'user/selectors';
import { getActiveField, isFieldFecthed } from 'current/selectors';
import { getOperationalTableViewUrl } from 'util/urls';

const baseString = 'back-to-table-view';

const BackToTableView = () => {
  const isOperationalTableView = useAppSelector(isOperationalTableViewEnabled);
  const field = useAppSelector(getActiveField);
  const isFetched = useAppSelector(isFieldFecthed);

  if (!isOperationalTableView) return null;

  return (
    <div data-test-id="back-to-table-view" className={baseString}>
      <a data-test-id="back-to-table-view-link" href={getOperationalTableViewUrl()}>
        <Button mode="negative_secondary" aria-label={getMessage('button-text__back-to-table-view')}>
          <Icon glyph={Icon.set.ARROW_BACK} />
        </Button>
      </a>
      <div>
        <span>{getMessage('title-text__back-to-table-view')}</span>
        {isFetched ? <h2>{field?.name}</h2> : <Skeleton height={28} width={150} /> }
      </div>
    </div>
  );
};

export default BackToTableView;
